var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"under-maintenance-page"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }